import angular from 'angular';

export default angular
    .module('asNotifier', ['growlNotifications'])
    .component('asNotifier', {
        template: require('./asNotifier.component.html'),
        style: require('./asNotifier.component.scss'),
        controller(asNotifier) {
            this.notifier = asNotifier;
        }
    });



// WEBPACK FOOTER //
// ./modules/shared/asNotifier/asNotifier.component.js